import { useEffect, useState } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import styles from './correct-score-adj-slider.module.scss';
import { CdnImg } from '@/features/cdn-img';
import { correctScoreSpreadAssetService } from '@/features/promotion-activity-modal/services/correct-score-spread-asset.service';
import { useRouter } from '@/navigation';
import { useGoToWcPromotionMenuUrl } from '@/domains/wc-promotion/hooks/use-wc-promotion-menu-url';
interface WorldCup2026SliderProps {
	onClose: () => void;
}

export const CorrectScoreAdjSlider = ({
	onClose,
}: WorldCup2026SliderProps) => {
	const t = useTranslations('General');
	const router = useRouter();
	const locale = useLocale();
	const defaultSrc = correctScoreSpreadAssetService.getAdjSliderImageSrc(locale);
	const [imageSrc, setImageSrc] = useState(defaultSrc);
	const goToWcPromotionMenuUrl = useGoToWcPromotionMenuUrl();

	useEffect(() => {
		setImageSrc(defaultSrc);
	}, [defaultSrc]);

	const handleImageError = () => {
		setImageSrc(
			correctScoreSpreadAssetService.getAdjSliderImageSrcForSuffix(correctScoreSpreadAssetService.fallbackSuffix),
		);
	};

	const handleClickButton = () => {
		goToWcPromotionMenuUrl();
		onClose();
	};

	return (
		<div className={styles.container}>
			<CdnImg
				className={styles.kv}
				src={imageSrc}
				width={288}
				height={341}
				alt="correct score adj slider"
				isGalaxyFolder={true}
				onError={handleImageError}
			/>
			<button
				className={styles.button}
				onClick={handleClickButton}
			>
				{t('lbl_CorrectScoreAdjPopup04')}
			</button>
		</div>
	)
}